import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function ErrorSnackBar({ open, mesage, close }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Snackbar onClose={close} open={open} autoHideDuration={6000}>
        <Alert onClose={close} severity="error">
          {mesage}
        </Alert>
      </Snackbar>
    </div>
  );
}
